import React from 'react';
import { useTranslation } from 'react-i18next';
import HowItWorksItem from './HowItWorksItem';

const HowItWorks = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="py-2">
        <div className="container">
          <h2 className="center p-1">{t('How It Works')}</h2>
          <div className="bottom-line"></div>
          <p className="center mb-3">{t('Steps to obtain a sick note (doctor certificate) using instoremed.com')}</p>

          <div className="row">
            <HowItWorksItem icon="1" title={t('Submit Request')} description={t('Complete our secure online form with your details and reason for absence.')} />
            <HowItWorksItem icon="2" title={t('Doctor Review')} description={t('Our licensed physicians review your request and may contact you if needed.')} />
            <HowItWorksItem icon="3" title={t('Payment')} description={t('Pay securely online once your request is approved.')} />
            <HowItWorksItem icon="4" title={t('Receive Note')} description={t('Your official sick note is emailed to you, usually within 1 business day.')} />
            <HowItWorksItem icon="5" title={t('Present to Employer')} description={t('Print or forward the doctor-issued note to your employer or school.')} />
            <HowItWorksItem icon="6" title={t('Keep Records')} description={t('Save a copy for your personal medical records.')} />
          </div>
        </div>
      </section>
    </>
  );
};

export default HowItWorks;
